// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QuoteDetailPage {
  width: 100%;
  min-height: 100vh;
}

/* Page Split Grid */
.adv-negotiation-grid {
  display: grid;
  grid-template-columns: 1.8fr 1fr;
  gap: 24px;
  align-items: start;
  margin-top: 24px;
}

@media (max-width: 991px) {
  .adv-negotiation-grid {
    grid-template-columns: 1fr;
  }
}

/* Chat thread container */
.adv-chat-thread {
  display: flex;
  flex-direction: column;
  height: 650px;
  background-color: #0e1b1b;
  border: 1.5px solid rgba(255, 255, 255, 0.07);
  border-radius: 12px;
  overflow: hidden;
}

/* Chat messages list scroll window */
.adv-chat-messages-container {
  flex-grow: 1;
  overflow-y: auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: rgba(0, 0, 0, 0.15);
}

/* Speech bubbles wrappers */
.adv-chat-row {
  display: flex;
  width: 100%;
}

.adv-chat-row--customer {
  justify-content: flex-end;
}

.adv-chat-row--provider {
  justify-content: flex-start;
}

.adv-chat-row--system {
  justify-content: center;
}

/* Chat speech bubble */
.adv-chat-bubble {
  max-width: 75%;
  padding: 12px 16px;
  border-radius: 12px;
  font-size: 14px;
  line-height: 1.5;
  color: #e6edf3;
  position: relative;
  border: 1.5px solid transparent;
}

.adv-chat-bubble--customer {
  background-color: #162a2a;
  border-color: #3bb3ae;
  border-bottom-right-radius: 2px;
}

.adv-chat-bubble--provider {
  background-color: #121e1e;
  border-color: rgba(255, 255, 255, 0.08);
  border-bottom-left-radius: 2px;
}

.adv-chat-bubble--system {
  background-color: rgba(255, 255, 255, 0.02);
  border-color: rgba(255, 255, 255, 0.04);
  color: #8b949e;
  text-align: center;
  max-width: 90%;
  font-size: 13px;
  border-radius: 20px;
  padding: 6px 16px;
}

/* Chat message sub-details */
.adv-chat-meta {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-top: 6px;
  font-size: 11px;
  color: #8b949e;
}

.adv-chat-meta--customer {
  justify-content: flex-end;
}

.adv-chat-meta--provider {
  justify-content: flex-start;
}

/* Embedded Quote Card in Thread */
.adv-thread-quote-card {
  background-color: #0b1414;
  border: 1.5px solid #48d1cc;
  border-radius: 10px;
  padding: 16px;
  margin-top: 8px;
  color: #fff;
}

.adv-thread-quote-card__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  padding-bottom: 8px;
  margin-bottom: 12px;
}

.adv-thread-quote-card__price {
  font-size: 20px;
  font-weight: 700;
  color: #28a745;
}

.adv-thread-quote-card__version {
  font-size: 12px;
  color: #48d1cc;
  background: rgba(72, 209, 204, 0.12);
  padding: 2px 8px;
  border-radius: 12px;
  font-weight: 700;
}

.adv-thread-quote-card__detail {
  font-size: 13px;
  line-height: 1.4;
  color: #cbd5e1;
  margin-bottom: 12px;
}

.adv-thread-quote-card__actions {
  display: flex;
  gap: 8px;
  margin-top: 12px;
}

/* Composer block */
.adv-chat-composer {
  background-color: #0c1818;
  border-top: 1.5px solid rgba(255, 255, 255, 0.07);
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.adv-chat-composer--locked {
  background-color: rgba(220, 53, 69, 0.03);
  text-align: center;
  color: #da3633;
  font-weight: 500;
  padding: 20px;
}

/* Textarea row */
.adv-chat-composer-row {
  display: flex;
  gap: 12px;
  align-items: flex-end;
}

.adv-chat-composer-textarea {
  flex-grow: 1;
  background: rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: #fff;
  padding: 10px 14px;
  font-size: 14px;
  font-family: inherit;
  resize: none;
  height: 44px;
  box-sizing: border-box;
  transition: border-color 0.2s;
}

.adv-chat-composer-textarea:focus {
  outline: none;
  border-color: #3bb3ae;
}

.adv-chat-send-btn {
  background-color: #3bb3ae;
  color: #071414;
  border: none;
  border-radius: 8px;
  height: 44px;
  padding: 0 20px;
  font-weight: 700;
  cursor: pointer;
  transition: opacity 0.2s;
}

.adv-chat-send-btn:hover {
  opacity: 0.9;
}

.adv-chat-send-btn:disabled {
  background-color: #2b4545;
  color: #777;
  cursor: not-allowed;
}

/* Attachments list */
.adv-chat-attachments-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.adv-chat-attachment-chip {
  background-color: rgba(255,255,255,0.05);
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 15px;
  padding: 3px 12px;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.adv-chat-attachment-chip-remove {
  background: none;
  border: none;
  color: #ff4d4f;
  cursor: pointer;
  font-weight: 700;
  font-size: 14px;
}

/* Action controls */
.adv-chat-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.adv-chat-controls-left {
  display: flex;
  gap: 8px;
}

.adv-chat-controls-right {
  display: flex;
  gap: 8px;
}

/* Quote Versions History Panel (Right Sidebar) */
.adv-versions-panel {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 24px;
}

.adv-version-item {
  background-color: #0e1b1b;
  border: 1.5px solid rgba(255, 255, 255, 0.07);
  border-radius: 8px;
  overflow: hidden;
  transition: border-color 0.2s;
}

.adv-version-item--pending {
  border-color: rgba(245, 200, 66, 0.25);
}

.adv-version-item--accepted {
  border-color: rgba(40, 167, 111, 0.35);
}

.adv-version-item__header {
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  background: rgba(255,255,255,0.01);
  transition: background 0.2s;
}

.adv-version-item__header:hover {
  background: rgba(255,255,255,0.03);
}

.adv-version-item__title {
  font-size: 14px;
  font-weight: 700;
  color: #fff;
}

.adv-version-item__price {
  font-size: 14px;
  font-weight: 700;
  color: #28a745;
}

.adv-version-item__status {
  font-size: 11px;
  text-transform: uppercase;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 4px;
}

.adv-version-item__body {
  padding: 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  background: rgba(0, 0, 0, 0.1);
  font-size: 13px;
  line-height: 1.5;
  color: #cbd5e1;
}

.adv-version-details-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  margin-top: 8px;
}

/* Chat Attachment Previews */
.adv-chat-message-attachments {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}

.adv-chat-message-attachment-thumb {
  max-width: 120px;
  max-height: 80px;
  border-radius: 6px;
  object-fit: cover;
  border: 1px solid rgba(255,255,255,0.1);
}

.adv-btn-spinner {
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: quoteDetailBtnSpin 0.8s linear infinite;
  display: inline-block;
}

@keyframes quoteDetailBtnSpin {
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/QuoteDetailPage/QuoteDetailPage.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,yBAAyB;EACzB,6CAA6C;EAC7C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,+BAA+B;AACjC;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA,uBAAuB;AACvB;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,uCAAuC;EACvC,8BAA8B;AAChC;;AAEA;EACE,2CAA2C;EAC3C,uCAAuC;EACvC,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,kCAAkC;AAClC;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kDAAkD;EAClD,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,oCAAoC;EACpC,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,iDAAiD;EACjD,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,0CAA0C;EAC1C,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,wCAAwC;EACxC,wCAAwC;EACxC,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,6CAA6C;EAC7C,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,QAAQ;EACR,eAAe;AACjB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,kDAAkD;EAClD,qBAAqB;AACvB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".QuoteDetailPage {\n  width: 100%;\n  min-height: 100vh;\n}\n\n/* Page Split Grid */\n.adv-negotiation-grid {\n  display: grid;\n  grid-template-columns: 1.8fr 1fr;\n  gap: 24px;\n  align-items: start;\n  margin-top: 24px;\n}\n\n@media (max-width: 991px) {\n  .adv-negotiation-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Chat thread container */\n.adv-chat-thread {\n  display: flex;\n  flex-direction: column;\n  height: 650px;\n  background-color: #0e1b1b;\n  border: 1.5px solid rgba(255, 255, 255, 0.07);\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n/* Chat messages list scroll window */\n.adv-chat-messages-container {\n  flex-grow: 1;\n  overflow-y: auto;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  background: rgba(0, 0, 0, 0.15);\n}\n\n/* Speech bubbles wrappers */\n.adv-chat-row {\n  display: flex;\n  width: 100%;\n}\n\n.adv-chat-row--customer {\n  justify-content: flex-end;\n}\n\n.adv-chat-row--provider {\n  justify-content: flex-start;\n}\n\n.adv-chat-row--system {\n  justify-content: center;\n}\n\n/* Chat speech bubble */\n.adv-chat-bubble {\n  max-width: 75%;\n  padding: 12px 16px;\n  border-radius: 12px;\n  font-size: 14px;\n  line-height: 1.5;\n  color: #e6edf3;\n  position: relative;\n  border: 1.5px solid transparent;\n}\n\n.adv-chat-bubble--customer {\n  background-color: #162a2a;\n  border-color: #3bb3ae;\n  border-bottom-right-radius: 2px;\n}\n\n.adv-chat-bubble--provider {\n  background-color: #121e1e;\n  border-color: rgba(255, 255, 255, 0.08);\n  border-bottom-left-radius: 2px;\n}\n\n.adv-chat-bubble--system {\n  background-color: rgba(255, 255, 255, 0.02);\n  border-color: rgba(255, 255, 255, 0.04);\n  color: #8b949e;\n  text-align: center;\n  max-width: 90%;\n  font-size: 13px;\n  border-radius: 20px;\n  padding: 6px 16px;\n}\n\n/* Chat message sub-details */\n.adv-chat-meta {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  margin-top: 6px;\n  font-size: 11px;\n  color: #8b949e;\n}\n\n.adv-chat-meta--customer {\n  justify-content: flex-end;\n}\n\n.adv-chat-meta--provider {\n  justify-content: flex-start;\n}\n\n/* Embedded Quote Card in Thread */\n.adv-thread-quote-card {\n  background-color: #0b1414;\n  border: 1.5px solid #48d1cc;\n  border-radius: 10px;\n  padding: 16px;\n  margin-top: 8px;\n  color: #fff;\n}\n\n.adv-thread-quote-card__header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  padding-bottom: 8px;\n  margin-bottom: 12px;\n}\n\n.adv-thread-quote-card__price {\n  font-size: 20px;\n  font-weight: 700;\n  color: #28a745;\n}\n\n.adv-thread-quote-card__version {\n  font-size: 12px;\n  color: #48d1cc;\n  background: rgba(72, 209, 204, 0.12);\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-weight: 700;\n}\n\n.adv-thread-quote-card__detail {\n  font-size: 13px;\n  line-height: 1.4;\n  color: #cbd5e1;\n  margin-bottom: 12px;\n}\n\n.adv-thread-quote-card__actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 12px;\n}\n\n/* Composer block */\n.adv-chat-composer {\n  background-color: #0c1818;\n  border-top: 1.5px solid rgba(255, 255, 255, 0.07);\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.adv-chat-composer--locked {\n  background-color: rgba(220, 53, 69, 0.03);\n  text-align: center;\n  color: #da3633;\n  font-weight: 500;\n  padding: 20px;\n}\n\n/* Textarea row */\n.adv-chat-composer-row {\n  display: flex;\n  gap: 12px;\n  align-items: flex-end;\n}\n\n.adv-chat-composer-textarea {\n  flex-grow: 1;\n  background: rgba(0, 0, 0, 0.25);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  color: #fff;\n  padding: 10px 14px;\n  font-size: 14px;\n  font-family: inherit;\n  resize: none;\n  height: 44px;\n  box-sizing: border-box;\n  transition: border-color 0.2s;\n}\n\n.adv-chat-composer-textarea:focus {\n  outline: none;\n  border-color: #3bb3ae;\n}\n\n.adv-chat-send-btn {\n  background-color: #3bb3ae;\n  color: #071414;\n  border: none;\n  border-radius: 8px;\n  height: 44px;\n  padding: 0 20px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n\n.adv-chat-send-btn:hover {\n  opacity: 0.9;\n}\n\n.adv-chat-send-btn:disabled {\n  background-color: #2b4545;\n  color: #777;\n  cursor: not-allowed;\n}\n\n/* Attachments list */\n.adv-chat-attachments-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.adv-chat-attachment-chip {\n  background-color: rgba(255,255,255,0.05);\n  border: 1px solid rgba(255,255,255,0.08);\n  border-radius: 15px;\n  padding: 3px 12px;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.adv-chat-attachment-chip-remove {\n  background: none;\n  border: none;\n  color: #ff4d4f;\n  cursor: pointer;\n  font-weight: 700;\n  font-size: 14px;\n}\n\n/* Action controls */\n.adv-chat-controls {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.adv-chat-controls-left {\n  display: flex;\n  gap: 8px;\n}\n\n.adv-chat-controls-right {\n  display: flex;\n  gap: 8px;\n}\n\n/* Quote Versions History Panel (Right Sidebar) */\n.adv-versions-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 24px;\n}\n\n.adv-version-item {\n  background-color: #0e1b1b;\n  border: 1.5px solid rgba(255, 255, 255, 0.07);\n  border-radius: 8px;\n  overflow: hidden;\n  transition: border-color 0.2s;\n}\n\n.adv-version-item--pending {\n  border-color: rgba(245, 200, 66, 0.25);\n}\n\n.adv-version-item--accepted {\n  border-color: rgba(40, 167, 111, 0.35);\n}\n\n.adv-version-item__header {\n  padding: 12px 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n  background: rgba(255,255,255,0.01);\n  transition: background 0.2s;\n}\n\n.adv-version-item__header:hover {\n  background: rgba(255,255,255,0.03);\n}\n\n.adv-version-item__title {\n  font-size: 14px;\n  font-weight: 700;\n  color: #fff;\n}\n\n.adv-version-item__price {\n  font-size: 14px;\n  font-weight: 700;\n  color: #28a745;\n}\n\n.adv-version-item__status {\n  font-size: 11px;\n  text-transform: uppercase;\n  font-weight: 700;\n  padding: 2px 6px;\n  border-radius: 4px;\n}\n\n.adv-version-item__body {\n  padding: 16px;\n  border-top: 1px solid rgba(255, 255, 255, 0.05);\n  background: rgba(0, 0, 0, 0.1);\n  font-size: 13px;\n  line-height: 1.5;\n  color: #cbd5e1;\n}\n\n.adv-version-details-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n/* Chat Attachment Previews */\n.adv-chat-message-attachments {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.adv-chat-message-attachment-thumb {\n  max-width: 120px;\n  max-height: 80px;\n  border-radius: 6px;\n  object-fit: cover;\n  border: 1px solid rgba(255,255,255,0.1);\n}\n\n.adv-btn-spinner {\n  width: 14px;\n  height: 14px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top-color: #ffffff;\n  border-radius: 50%;\n  animation: quoteDetailBtnSpin 0.8s linear infinite;\n  display: inline-block;\n}\n\n@keyframes quoteDetailBtnSpin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
